namespace Areas.Dialogs.FilterBuilder {
    "use strict";

    export class FilterBuilderDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any = null) {
            super("FilterBuilder", closeHandler, parameters, () => {
                const filterBuilder = $(`#${this.dialogName}Control`).dxFilterBuilder({
                    fields: parameters.fields,
                    value: parameters.filterValue
                });
                
            });
        }

        protected ok = (e: any) => {

            const filterBuilder = $(`#${this.dialogName}Control`).dxFilterBuilder('instance');
            const data = {
                gridName: this.parameters.gridName,
                filter: filterBuilder.option("value")
            };

            this.close(DialogResult.Ok, data);
            }
        } 

    }
